import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";

// custom hooks import
import useISPowner from "../../../hooks/useISPOwner";

// internal import
import "../../message/message.css";
import Loader from "../../../components/common/Loader";
import { recharge, rechargeHistoryEdit } from "../../../features/apiCalls";
import { FtextField } from "../../../components/common/FtextField";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import useDataInputOption from "../../../hooks/useDataInputOption";
import { toast } from "react-toastify";

const ResellerRecharge = ({
  show,
  setShow,
  isUpdate,
  resellerId,
  rechargeId,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // get user & current user data form useISPOwner hooks
  const { ispOwnerId } = useISPowner();

  // get recharge history form redux
  const rechargeHistory = useSelector(
    (state) => state.recharge.rechargeHistory
  );

  // find single data
  const data = rechargeHistory.find((item) => item.id === rechargeId);

  // call the data input option function
  const inputPermission = {
    ...(isUpdate ? "" : { amount: true }),
    paymentStatus: true,
  };

  // get data input option from useDataInputOption hook
  const dataInputOption = useDataInputOption(
    inputPermission,
    null,
    null,
    isUpdate ? data : null
  );

  // get all reseller data from redux store
  const allReseller = useSelector((state) => state?.reseller?.reseller);

  // single reseller find by id
  const reseller = allReseller.find((val) => {
    return val.id === resellerId;
  });

  // loading state
  const [isLoading, setIsloading] = useState(false);

  //recharge Handler
  const rechargeHandler = (formValues) => {
    if (formValues.amount < 1) {
      toast.error("Amount must be greater than 1");
    }

    const data = {
      ...formValues,
      ...(isUpdate
        ? ""
        : {
            ispOwner: ispOwnerId,
            reseller: reseller.id,
          }),
    };

    if (isUpdate) {
      rechargeHistoryEdit(dispatch, rechargeId, data, setIsloading, setShow);
    } else {
      recharge(data, setIsloading, dispatch, setShow);
    }
  };
  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        centered={false}
        size={"md"}
        header={t("rechargeAmount")}
      >
        <Formik
          initialValues={{
            ...dataInputOption.inputInitialValues,
          }}
          validationSchema={dataInputOption.validationSchema}
          onSubmit={(values) => {
            rechargeHandler(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form>
              <div className="displayGrid">
                {dataInputOption?.inputOption.map(
                  (item) => item?.isVisible && <FtextField {...item} />
                )}

                <div>
                  <label className="changeLabelFontColor" htmlFor="comment">
                    {t("addComment")}
                  </label>

                  <Field
                    className="form-control shadow-none"
                    style={{
                      height: "70px",
                      width: "100%",
                      padding: "10px",
                    }}
                    component="textarea"
                    name="comment"
                  />
                </div>
              </div>

              <div className="displayGrid1 float-end mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShow(false)}
                >
                  {t("cancel")}
                </button>

                <button type="submit" className="btn btn-success">
                  {isLoading ? <Loader /> : t("recharge")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default ResellerRecharge;
